import React, { memo } from 'react';

import { TableContainer, BaseTableProps /* BaseGenericTableProps */ } from '../../components';

type RoomTypesTableProps = {} & BaseTableProps /* & BaseGenericTableProps<AccommodationModel> */;

const RoomTypesTable: React.FunctionComponent<RoomTypesTableProps> = memo(props => {
    console.debug('RoomTypesTable');

    return <TableContainer {...props} columns={props.columns} dataSourcePath="" />;
});

export default RoomTypesTable;
